<template>
  <Main>
    <BrokersTable/>
  </Main>
</template>
<script>
import BrokersTable from "../components/BrokersTable.vue";

export default {
  components: {
      BrokersTable
  }
};
</script>
